import { createFileRoute, Link } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, ArrowLeft, Download, Mail } from "lucide-react";

export const Route = createFileRoute("/_authenticated/subscription-success")({
  component: SubscriptionSuccessPage,
});

function SubscriptionSuccessPage() {
  return (
    <div className="container mx-auto py-12 max-w-4xl">
      <div className="text-center mb-10">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-green-100 mb-6">
          <CheckCircle className="h-10 w-10 text-green-600" />
        </div>
        <h1 className="text-4xl font-bold tracking-tight mb-4">
          ¡Suscripción Exitosa!
        </h1>
        <p className="text-xl text-muted-foreground">
          Gracias por suscribirte a nuestro servicio
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Download className="h-5 w-5" />
              Próximos pasos
            </CardTitle>
            <CardDescription>
              Esto es lo que sucederá a continuación
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-start gap-3">
              <div className="bg-primary/10 p-2 rounded-full">
                <Mail className="h-4 w-4 text-primary" />
              </div>
              <div>
                <h3 className="font-semibold">
                  Recibirás un correo de confirmación
                </h3>
                <p className="text-sm text-muted-foreground">
                  Enviamos un correo con los detalles de tu suscripción y el
                  recibo de pago
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="bg-primary/10 p-2 rounded-full">
                <CheckCircle className="h-4 w-4 text-primary" />
              </div>
              <div>
                <h3 className="font-semibold">Acceso inmediato</h3>
                <p className="text-sm text-muted-foreground">
                  Tu cuenta ya está activada con todas las funcionalidades del
                  plan seleccionado
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="bg-primary/10 p-2 rounded-full">
                <ArrowLeft className="h-4 w-4 text-primary" />
              </div>
              <div>
                <h3 className="font-semibold">
                  Puedes comenzar a usar la plataforma
                </h3>
                <p className="text-sm text-muted-foreground">
                  Regresa al dashboard para empezar a utilizar todas las
                  características
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Detalles de tu suscripción</CardTitle>
            <CardDescription>Resumen de lo que has adquirido</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex justify-between items-center">
              <span className="text-muted-foreground">Plan seleccionado</span>
              <span className="font-semibold">Plan Profesional</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-muted-foreground">Precio mensual</span>
              <span className="font-semibold">$79.00 USD</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-muted-foreground">Próxima facturación</span>
              <span className="font-semibold">En 30 días</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-muted-foreground">Estado</span>
              <span className="px-3 py-1 rounded-full bg-green-100 text-green-800 text-sm font-medium">
                Activa
              </span>
            </div>
          </CardContent>
          <CardFooter className="flex flex-col gap-4">
            <Button asChild className="w-full" variant="outline">
              <Link to="/dashboard">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Volver al Dashboard
              </Link>
            </Button>
            <Button asChild className="w-full">
              <Link to="/subscriptions">Gestionar Suscripción</Link>
            </Button>
          </CardFooter>
        </Card>
      </div>

      <div className="mt-12 text-center">
        <Card className="border-dashed">
          <CardContent className="pt-6">
            <h3 className="font-semibold text-lg mb-2">¿Necesitas ayuda?</h3>
            <p className="text-muted-foreground mb-4">
              Nuestro equipo de soporte está disponible para ayudarte
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button variant="outline" asChild>
                <a href="/help">Centro de Ayuda</a>
              </Button>
              <Button variant="outline" asChild>
                <a href="mailto:soporte@empresa.com">
                  <Mail className="mr-2 h-4 w-4" />
                  Contactar Soporte
                </a>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
